import { Component, Vue } from 'vue-property-decorator';
import WithRender from './customertransactions.html';
import config from "@/settings/config.js";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import _axios from '@/services/axios';
import moment from 'moment';
import Datepicker from 'vuejs-datepicker';
import { mapGetters } from 'vuex';

@WithRender
@Component({
  filters: {
    formateDate(value: string) {
      return moment(value).format('YYYY-MM-DD HH:mm A')
    }
  },
  components: {
    Loading,
    Datepicker
  },
  computed: {
    ...mapGetters("originatorStore", { currency: "getWalletCurrency" }),
  }
})
export default class customertransactions extends Vue {
  currency!: string;
  isLoading = false;
  fromDate = new Date();
  toDate = new Date();
  customer ="";
  userId='';
  perPage = 10;
  currentPage = 1;
  selectedPage = 1;
  totalTransactions = 0;
  totalRecords = 0;
  totalSalesValue = 0;
  totalDiscountReceived = 0;
  items = [];
  fields = [
    {
      key: "month",
      label: "Month",
      sortable: true,
    },
    {
      key: "customer",
      label: "Customer",
      sortable: true,
    },
    {
      key: "product",
      label: "Product",
      sortable: true,
    },
    {
      key: "transactions",
      label: "Transaction Count",
      sortable: true,
    },
    {
      key: "discountReceived",
      label: "Discount Received",
      sortable: true,
    },
    {
      key: "salesValue",
      label: "Sales Value",
      sortable: true
    },
  ]
  customFormatter(date: Date) {
    return moment(date).format('yyyy-MM-DD');
  }

  monthInFull(monthValue: number): string {
    var months = [
      "January",
      "Febraury",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    return months[monthValue-1];
  }
  mounted() {
    this.getTransactions();
    this.userId = this.$route.params.userId as string;
  }

  handlePageClick() {
    if (this.currentPage === this.selectedPage)
      return;
    this.currentPage = this.selectedPage;
    this.getTransactions()
  }

  getTransactions(): void {
    this.isLoading = true;
    _axios.get(`${config.gateway}payment/admin/CustomerReport/CustomerTransactions?CurrentPage=${this.currentPage}&PageSize=${this.perPage}&DateFrom=${this.customFormatter(this.fromDate)}&DateTo=${this.customFormatter(this.toDate)}&customer=${this.customer}&userId=${this.userId}`)
      .then(response => {
        console.log(this.items);
        this.items = response.data.customerTransactions;
        this.totalRecords = response.data.totalRowCount;
        this.totalSalesValue = response.data.totalSalesValue;
        this.totalDiscountReceived = response.data.totalDiscountReceived;
        this.totalTransactions = response.data.totalTransactions;
      })
      .catch(err => { console.error(err); })
      .finally(() => {
        this.isLoading = false;
      });
  }
}
